import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface StepsReducer {
    currentStep: number;
}

export const initialState: StepsReducer = {
    currentStep: 1,
};

export const stepsReducer = (state = initialState, action: AppActions = {} as AppActions): StepsReducer => {
    switch (action.type) {
        case actionTypes.OPEN_STEP: {
            const { destinationStep } = action.payload;
            return {
                currentStep: destinationStep,
            };
        }
        case actionTypes.SEND_APPLICATION_FULFILLED: {
            return {
                ...state,
                currentStep: 5,
            };
        }
        case actionTypes.FETCH_STATUS_FULFILLED: {
            const { status } = action.payload.response;
            if (status === 'INNVILGET' || status === 'KONTROLL' || status === 'AVSLAATT') {
                return {
                    ...state,
                    currentStep: 5,
                };
            }
            return state;
        }
        case actionTypes.FETCH_CASE_FULFILLED: {
            const { status } = action.payload;
            if (status === 'INNVILGET' || status === 'KONTROLL' || status === 'AVSLAATT') {
                return {
                    ...state,
                    currentStep: 5,
                };
            }
            return state;
        }

        default:
            return state;
    }
};
